export default __webpack_public_path__ + "static/media/TransactionIconFooter.635fc68a.svg";